module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc19-161a85ec7979d1f1ab570b32f481989a.jpg";